import React from "react"
import CustomInput from "../../../../components/UI/Input/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Translation } from "react-i18next";
import AddressPopup from "../AddressPopup/AddressPopup";

const AddressCard = ({ address, index, action, deleteAddress }) => (
    <Translation>
        {t =>
            <div className="profile-addresses-card">
                <div className="address-header">
                    <div className="address-title">{t("addressCard.address")} {index + 1}</div>
                    {!address.readOnly &&
                        <AddressPopup
                            address={address}
                            action={action}
                            deleteAddress={deleteAddress}
                            title={t("addresses.update")}
                            button={t("save")}
                            isUpdate={true}
                            trigger={
                                <button className="update-button outline">
                                    <FontAwesomeIcon icon="edit" />
                                    <span>{t("edit")}</span>
                                </button>
                            }
                        />
                    }
                </div>
                <div className="address-info">
                    <div className="row address-row">
                        <div className="col-sm-8">
                            <CustomInput
                                label="House Name/Number, Street Name*"
                                type="text"
                                value={address && address.address}
                                disabled
                            />
                        </div>
                        <div className="col-sm-4">
                            <CustomInput
                                label="City"
                                type="text"
                                value={address && address.city}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="row address-row">
                        <div className="col-sm-8">
                            <CustomInput
                                label="Country"
                                type="text"
                                value={address && address.nation}
                                disabled
                            />
                        </div>
                        <div className="col-sm-4">
                            <CustomInput
                                label="Post Code"
                                type="text"
                                value={address && address.zip}
                                disabled
                            />
                        </div>
                    </div>
                </div>
            </div>
        }
    </Translation>
);

export default AddressCard;